import React from 'react';
import { Page, SkeletonBar } from '@/components/app/ui';

/**
 * Mirrors the dashboard grid exactly — same column spans, same heights — so the
 * skeleton settles into the real layout instead of being replaced by it.
 */
export default function PageSkeleton() {
  return (
    <Page>
      <div className="flex items-start justify-between gap-3 mb-5 md:mb-6">
        <div className="space-y-2">
          <SkeletonBar className="h-7 w-40" />
          <SkeletonBar className="h-3.5 w-56" />
        </div>
        <div className="hidden md:flex items-center gap-2.5">
          <SkeletonBar className="h-10 w-36" />
          <SkeletonBar className="h-10 w-24" />
          <SkeletonBar className="h-10 w-36" />
        </div>
      </div>

      <div className="grid grid-cols-12 gap-3 md:gap-4">
        <SkeletonBar className="col-span-12 lg:col-span-5 h-[168px]" />
        <div className="col-span-12 lg:col-span-7 grid grid-cols-2 min-[430px]:grid-cols-4 gap-3 md:gap-4">
          {[0, 1, 2, 3].map((i) => (
            <SkeletonBar key={i} className="h-[168px]" />
          ))}
        </div>
        <SkeletonBar className="col-span-12 lg:col-span-8 h-[300px] md:h-[380px]" />
        <div className="col-span-12 lg:col-span-4 grid gap-3 md:gap-4">
          <SkeletonBar className="h-[180px]" />
          <SkeletonBar className="h-[184px]" />
        </div>
        <SkeletonBar className="col-span-12 h-[260px] hidden md:block" />
      </div>
    </Page>
  );
}
